import { render, staticRenderFns } from "./AppPopupWrapper.vue?vue&type=template&id=f437780c&scoped=true"
import script from "./AppPopupWrapper.vue?vue&type=script&lang=js"
export * from "./AppPopupWrapper.vue?vue&type=script&lang=js"
import style0 from "./AppPopupWrapper.vue?vue&type=style&index=0&id=f437780c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f437780c",
  null
  
)

export default component.exports